import { CircleIcon } from "@/components/ui/icon";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { RadioGroup, Radio, RadioIndicator, RadioIcon, RadioLabel } from "@/components/ui/radio";
import React from 'react';
import i18n from "i18n-js";
import FloatingLabelInput from "../../components/basic/FloatingLabelInput";
import { ScrollView } from "react-native-gesture-handler";

const RadioButton = (props) => {
    return (
        <Radio value={props.value}>
            <RadioIndicator className="mr-1">
                <RadioIcon as={CircleIcon} strokeWidth={1} />
            </RadioIndicator>
            <RadioLabel>{props.children}</RadioLabel>
        </Radio>
    );
}

export default function InfoReport({ type, setType, info, setInfo }) {
    return (
        <>
            <ScrollView height='30%'>
                <RadioGroup name="myRadioGroup" value={type} onChange={itemValue => setType(itemValue)} aria-label={i18n.t('report.type')}>
                    <VStack space='sm'>
                        <RadioButton value="TRADEMARK_VIOLATION">{i18n.t('report.trademark_violation')}</RadioButton>
                        <RadioButton value="HARASSMENT">{i18n.t('report.harassment')}</RadioButton>
                        <RadioButton value="HATE">{i18n.t('report.hate')}</RadioButton>
                        <RadioButton value="DRUG_CONSUMTION">{i18n.t('report.drug_consumtion')}</RadioButton>
                        <RadioButton value="PORNOGRAFIC_MATERIAL">{i18n.t('report.pornografic_material')}</RadioButton>
                        <RadioButton value="VIOLENCE">{i18n.t('report.violence')}</RadioButton>
                        <RadioButton value="GAMBLING">{i18n.t('report.gambling')}</RadioButton>
                        <RadioButton value="OTHER">{i18n.t('report.other')}</RadioButton>
                    </VStack>
                </RadioGroup>
            </ScrollView>
            <View className="w-[100%] pt-2">
                <FloatingLabelInput label={i18n.t('report.description')} size='sm' h='h-[100px]' blurOnSubmit={true} enterKeyHint='done' multiline={true} onChangeText={setInfo} value={info} />
            </View>
        </>
    );
}